import { useFormContext, UseFormReturn } from 'react-hook-form';

import { AppError } from '@/utils';

import { ManageCreditForm } from '.';

export const useManageCreditFormContext = ():
  | UseFormReturn<ManageCreditForm>
  | never => {
  const form = useFormContext<ManageCreditForm>();

  if (form === null)
    throw AppError.hookScopeError(
      'useManageCreditFormContext can only be used inside a Manage Credit Form Context Provider.',
    );

  return form;
};
